export default {
  router_home: "首頁",
  router_order: "訂單",
  router_my: "我的",
  router_idCard: "身份驗證",
  router_confirm_loan: "確認借款",
  router_confirm_withdrawal: "確認領取",
  router_basicInformation: "基礎資訊",
  router_work: "工作資訊",
  router_other: "其他資訊",
  account_info: "賬戶信息",
  router_face: "人臉辨識",
  router_details: "訂單詳情",
  router_loanDetail: "確認借款",
  router_repayMethods: "還款方式",
  router_addBackCard: "新增銀行卡",
  router_selectBackCard: "選擇銀行卡",
  router_pay_immediately: "立即還款",
  router_pay_rollover: "展期還款",
  router_back: "銀行帳號支付",
  router_companyPay: "對公轉帳",
  router_belowLine: "線下支付",
  router_login: "登入",
  router_personal_data: "我的資料",
  router_help: "幫助中心",
  router_privacy_policy: "隱私權政策",
  router_login_reset: "重設密碼",
  router_login_setPwd: "設定密碼",
}